import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Login from "components/auth/Login";
import Header from "components/common/Header";
import LeftSideBar from "components/common/LeftSideBar";
import React, { lazy, useEffect, useState } from "react";
import { routes } from "./sidebar";
import { Skeleton } from "@mui/material";
import ErrorBoundary from "components/common/ErrorBoundary";
import { getLocalConfig } from "utils";
import useCookie from "hooks/useCookie";
import { useAdminAuth } from "context/context";
import ResetPassword from "components/auth/ResetPassword";
import ForgotPassword from "components/auth/ForgotPassword";
import Error from "components/not-found/Error";

export default function Routing() {
  const { cookies } = useCookie();
  const { roles } = useAdminAuth();

  const CommonHeading = () => {
    const [fullMenu, setFullMenu] = useState(true);

    useEffect(() => {
      const menu = getLocalConfig("menu");
      if (menu !== "" && menu !== "undefined") {
        setFullMenu(menu);
      }
    }, []);

    return (
      <>
        <Header fullMenu={fullMenu} setFullMenu={setFullMenu} />
        <LeftSideBar fullMenu={fullMenu} setFullMenu={setFullMenu} />
        {/* <div className={fullMenu ? "WrapperArea" : "WrapperArea-Small"}>
          <Outlet />
        </div> */}
        <ErrorBoundary fullMenu={fullMenu}>
          <React.Suspense
            fallback={
              <div className={fullMenu ? "WrapperArea" : "WrapperArea-Small"}>
                <div className="WrapperBox">
                  <Skeleton
                    variant="rounded"
                    width={"100%"}
                    height={"100vh"}
                    animation="wave"
                  />
                </div>
              </div>
            }
          >
            <div className={fullMenu ? "WrapperArea" : "WrapperArea-Small"}>
              <Outlet />
            </div>
          </React.Suspense>
        </ErrorBoundary>
      </>
    );
  };

  //protected routes
  const ProtectedRoute = ({ children }) => {
    // This code needs to be uncomment
    if (!cookies) {
      return <Navigate to="/" replace />;
    } else {
      return children;
    }
    // return children;
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route element={<CommonHeading />}>
          {routes(roles).map(({ path, element }) => {
            return (
              <Route
                key={path}
                path={path}
                element={<ProtectedRoute>{element}</ProtectedRoute>}
              />
            );
          })}
        </Route>
        <Route path="*" element={<Error />} />
      </Routes>
    </>
  );
}
